import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import type { FormDraftPatchInput } from "@colab/shared";

// PATCH /api/portal/forms/drafts/:submissionId — auto-save. The orchestrator
// hook (use-form-runtime) debounces the firing at 500ms.
//
// **No cache invalidation.** The draft payload lives in react-hook-form
// local state during editing; invalidating `portal.forms.detail(slug)` here
// would refetch the server's view and clobber any in-flight edits. The
// "Saving / Saved / Error" indicator the UI shows is driven by this
// mutation's isPending / isSuccess / isError flags, not by query state.
//
// Bucket 9 convention: local-state optimism only.
export function useSaveDraft(submissionId: string | null) {
  return useMutation<{ ok: true }, ApiClientError, FormDraftPatchInput>({
    mutationFn: async (body) => {
      if (!submissionId) {
        throw new ApiClientError(
          0,
          "no_submission_id",
          "Cannot save: missing submission id",
        );
      }
      return apiFetch<{ ok: true }>(
        `/portal/forms/drafts/${submissionId}`,
        {
          method: "PATCH",
          body: JSON.stringify(body),
        },
      );
    },
  });
}
